import {colors, fonts} from '@/theme';
import {Icon, Modal, Text} from '@/ui-kits';
import {formatCurrency} from '@/utils/common_functions';

interface HospitalFeesModalProps {
  open: boolean;
  onClose: () => void;
  originalFee: number;
  newFee: number;
  onConfirm: () => void;

  variant?: 'hospital-profile' | 'specalist-onboard';
}
export function HospitalFeesModal(props: HospitalFeesModalProps) {
  const {newFee, onClose, open, originalFee, variant = 'hospital-profile'} = props;
  return (
    <Modal open={open} className="rounded-2xl py-6 items-center relative gap-6 flex flex-col max-w-[600px]">
      <button className="cursor-pointer absolute top-3 right-3" onClick={onClose}>
        <Icon type="close" />
      </button>
      <Icon type="yellow_warning" className="size-16" />
      <Text variant="title" className="text-ui_blue text-center">
        {variant === 'hospital-profile' ? 'Update Hospital Default Consultation Fee.' : 'Update Doctor Consultation Fee.'}
      </Text>
      {variant === 'hospital-profile' ? (
        <Text variant="body" className="text-ui_text_blue_light text-center">
          You are changing the hospital default consultation fee from{' '}
          <span style={{color: colors.palette.ui_blue, fontFamily: fonts.InterSemiBold}}>{formatCurrency(originalFee)}</span> to{' '}
          <span style={{color: colors.palette.ui_blue, fontFamily: fonts.InterSemiBold}}>{formatCurrency(newFee)}</span>.
        </Text>
      ) : (
        <Text variant="body" className="text-ui_text_blue_light text-center">
          You are changing this doctor's consultation fee from <span>{formatCurrency(originalFee)}</span> to <span>{formatCurrency(newFee)}</span>. This
          fee will be applied only to this doctor and will be shown to patients during booking. 
        </Text>
      )}
      {variant === 'hospital-profile' ? (
        <Text variant="body" className="text-ui_text_blue_light text-center">
          This updated fee will apply only to doctors who are currently using the hospital default consultation fee. Doctors with customized consultation fees
          will not be affected.
        </Text>
      ) : (
        <Text variant="body" className="text-ui_text_blue_light text-center">
          The hospital default consultation fee and other doctors under this hospital will not be affected.
        </Text>
      )}
    </Modal>
  );
}
